module.exports = __webpack_public_path__ + "media/成都有哪些人才政策.f0ed4d27.mp4";